import { Injectable } from "@angular/core";
import { decryptData, fetchData, IRequestObject } from "@npm-bbta/bbog-sg-sandbox-lib";
import { environment } from "../../../../environments/environment";
import { IDecryptProperties } from "@npm-bbta/bbog-sg-sandbox-lib/models/IDecryptProperties";
import { CustomLogger } from "@npm-bbta/bbog-sg-frontend-logs-lib";
import { AxiosResponse } from "axios";

export type HttpMethod = "GET" | "POST" | "PUT" | "DELETE";

export interface SandboxRequest {
    url: string;
    headers: Record<string, string>;
    unencryptedHeaders?: Record<string, string>;
    body?: any;
    queryParams?: Record<string, string>;
    uuid: string;
}

export interface SandboxResponse {
    status: number;
    body: any;
    headers: AxiosResponse["headers"];
}

const logger = new CustomLogger("SandboxService", "hotpink");

@Injectable()
export class SandboxService {
    async request(method: HttpMethod, opts: SandboxRequest) {
        const requestObject: IRequestObject = {
            body: {
              method,
              originHeader: "Amazon CloudFront",
              headers: opts.headers as any,
              body: opts.body,
              queryParams: opts.queryParams,
              uri: opts.url,
              encryptKey: environment.sandbox.pk,
              properties: environment.propertiesSandbox,
              uuid:
              opts.headers["X-Auth-Token"] ?? opts.headers["X-RqUID"],
            },
          };
        const decryptProps: IDecryptProperties = {
            decryptKey: environment.sandbox.sk,
            properties: environment.propertiesSandbox,
        };

        try {
            const response = await fetchData(requestObject);
            response.body = decryptData(response, decryptProps);
            logger.log(`Response from ${method}:${opts.url}`, response);
            return response as SandboxResponse;
        } catch (error) {
            logger.error(`Error calling ${method}:${opts.url}`, error);
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/sandbox/sandbox.service.ts